import React from 'react';
import { Carousel } from 'react-bootstrap';
import banner1 from '../img/banner1.jpg';
import banner2 from '../img/dbanner1.jpg';
import banner3 from '../img/Banner2.jpg';
import banner4 from '../img/dbanner2.jpg';
import banner5 from '../img/banner3.jpg';
import banner6 from '../img/dbanner3.jpg';

import '../css/carousal.css'

const Carousal = () => {
  return (
    <div className="carousel-container">
      <Carousel interval={3000} pause="hover">
        <Carousel.Item>
          <img className="d-block w-100" src={banner1} alt="First slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={banner2} alt="Second slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={banner3} alt="Third slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={banner4} alt="Fourth slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={banner5} alt="Fifth slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={banner6} alt="Sixth slide" />
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default Carousal;
